module.exports = __webpack_public_path__ + "static/img/pico47.1b78bde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico47.png
// module id = WdHl
// module chunks = 0